class log {
	
	
	constructor(map, updateState){
		this.versions = [];
		this.current = 0;
		this.setHasChanges = updateState;
		this.map = map;
		
	}
	reset(firstItem){
		this.versions = [];
		this.current = 0;
		this.setHasChanges(false);
		this.map.controlBar.disable(['undo', 'redo']);
		this.add(firstItem);
	}
	add(item){
		
		this.versions.splice(this.current+1);
		var n = JSON.parse(JSON.stringify(item)); //make a copy
		this.versions = [...this.versions, n];
		
		
		this.current = this.versions.length -1;
		
		if(this.current){
			this.setHasChanges(true);
			this.map.controlBar.enable('undo');
		}
		this.map.controlBar.disable('redo');
	}
	
	back(count){
		if(this.versions.length>(count ?? 1) && this.current > 0){
			var x = JSON.parse(JSON.stringify(this.versions[this.current -= count ?? 1]));
			
			if(!this.current){
				this.setHasChanges(false);
				this.map.controlBar.disable('undo');
			}
			if((this.versions.length-this.current) > 1){
				this.map.controlBar.enable('redo');
			}
			return x;
		}
	}
	forward(){
		if(this.versions.length && this.current<(this.versions.length-1)){
			var x = JSON.parse(JSON.stringify(this.versions[++this.current]));
			
			if(this.current == (this.versions.length-1)){
				this.map.controlBar.disable('redo');
				
				
			}
			this.map.controlBar.enable('undo');
			this.setHasChanges(true);
			
			return x;
		}
		
	}
}
export default log;